/* ------------------------------------------------------------ *\
  Here goes the custom JS work
\* ------------------------------------------------------------ */

(function($) {
  // jQuery code should be wrapped here
  jQuery(document).ready(function() {
    /* Secondary nav should not scroll on mobile
    if($(window).width() < 1024){
      $(window).on('scroll', function(){
        if($(window).scrollTop() > 0){
          $('.nav-secondary.open').addClass('mobile-hide-onscroll');
        } else {
          $('.nav-secondary.open').removeClass('mobile-hide-onscroll');
        }
      });
    }*/

    $('.slider-intro .slider__slide').on('click', function(){
      var goTo = $(this).find('a').attr('href');
      window.location.href = goTo;
    });

    /*$(window).on('scroll', function(){
      if($(window).scrollTop() > 5 && $(window).width() < 1024){
        $('.nav-secondary').removeClass('open');
      } else {
        $('.nav-secondary').addClass('open');
      }
    });*/

    var selectCount = 0;
    if ($(".product__content").find("#option1").length) {
      selectCount = 1;
    }
    if ($(".product__content").find("#option2").length) {
      selectCount = 2;
    }
    if ($(".product__content").find("#option3").length) {
      selectCount = 3;
    }
    function checkAndChange() {
      if (selectCount == 0) {
        $("[data-available]")
          .first()
          .each(function() {
            if ($(this).attr("data-available") == "true") {
              $("#AddToCart-product-template").removeClass("btn--outOfStock");
              $("#AddToCart-product-template").text("ADD TO CART");
              $("#AddToCart-product-template").val("ADD TO CART");
              $("#AddToCart-product-template").prop("disabled", false);
            } else {
              $("#AddToCart-product-template").addClass("btn--outOfStock");
              $("#AddToCart-product-template").text("OUT OF STOCK");
              $("#AddToCart-product-template").val("OUT OF STOCK");
              $("#AddToCart-product-template").prop("disabled", true);
            }
          });
      } else if (selectCount == 1) {
        var targetValue1 = $("#option1").val();
        var target = $('[data-option1*="' + targetValue1 + '"]');
        var available = target.first().attr("data-available");
        if (available == "true") {
          $("#AddToCart-product-template").removeClass("btn--outOfStock");
          $("#AddToCart-product-template").text("ADD TO CART");
          $("#AddToCart-product-template").val("ADD TO CART");
          $("#AddToCart-product-template").prop("disabled", false);
        } else {
          $("#AddToCart-product-template").addClass("btn--outOfStock");
          $("#AddToCart-product-template").text("OUT OF STOCK");
          $("#AddToCart-product-template").val("OUT OF STOCK");
          $("#AddToCart-product-template").prop("disabled", true);
        }
      } else if (selectCount == 2) {
        var available = "false";
        var targetValue1 = $("#option1").val();
        var targetValue2 = $("#option2").val();
        var target = $('[data-option1*="' + targetValue1 + '"]');
        target.each(function() {
          if ($(this).attr("data-option2") == targetValue2) {
            available = $(this).attr("data-available");
            return false;
          }
        });
        if (available == "true") {
          $("#AddToCart-product-template").removeClass("btn--outOfStock");
          $("#AddToCart-product-template").text("ADD TO CART");
          $("#AddToCart-product-template").val("ADD TO CART");
          $("#AddToCart-product-template").prop("disabled", false);
        } else {
          $("#AddToCart-product-template").addClass("btn--outOfStock");
          $("#AddToCart-product-template").text("OUT OF STOCK");
          $("#AddToCart-product-template").val("OUT OF STOCK");
          $("#AddToCart-product-template").prop("disabled", true);
        }
      } else if (selectCount == 3) {
        var available = "false";
        var targetValue1 = $("#option1").val();
        var targetValue2 = $("#option2").val();
        var targetValue3 = $("#option3").val();

        var target = $('[data-option1*="' + targetValue1 + '"]');
        var dualCount = [];
        target.each(function() {
          if ($(this).attr("data-option2") == targetValue2) {
            dualCount.push($(this));
          }
        });
        for (j = 0; j < dualCount.length; j++) {
          if (dualCount[j].attr("data-option3") == targetValue3) {
            available = dualCount[j].attr("data-available");
          }
        }
        if (available == "true") {
          $("#AddToCart-product-template").removeClass("btn--outOfStock");
          $("#AddToCart-product-template").text("ADD TO CART");
          $("#AddToCart-product-template").val("ADD TO CART");
          $("#AddToCart-product-template").prop("disabled", false);
        } else {
          $("#AddToCart-product-template").addClass("btn--outOfStock");
          $("#AddToCart-product-template").text("OUT OF STOCK");
          $("#AddToCart-product-template").val("OUT OF STOCK");
          $("#AddToCart-product-template").prop("disabled", true);
        }
      }
    }
    checkAndChange();

    $("select").on("change", function() {
      checkAndChange();
    });

    setTimeout(function() {
      if (jQuery(".section-feeds .trigger").css("color") === "rgb(0, 0, 255)") {
        jQuery(".section-feeds .section__content").css(
          "height",
          jQuery(".section-feeds .section__asidenew").css("height")
        );
      }

      $(window).resize(function() {
        if (
          jQuery(".section-feeds .trigger").css("color") === "rgb(0, 0, 255)"
        ) {
          jQuery(".section-feeds .section__content").css(
            "height",
            jQuery(".section-feeds .section__asidenew").css("height")
          );
        }
      });
    }, 4000);

    // New Header Search Functionality

    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    $("[prevent-click]").click(function(e) {
      e.preventDefault();
    });

    function showHeaderSearch() {
      var $searchInput = $('#shopify-section-header input[type="search"]');

      $searchInput.css({
        width: "258px",
        "border-width": "1px",
        padding: "0 20px"
      });
    }

    function hideHeaderSearch() {
      var $searchInput = $('#shopify-section-header input[type="search"]');

      $searchInput.css({
        width: "0px",
        "border-width": "0px",
        padding: "0 0px"
      });
    }

    var pressedOnce = 0;
    $(".btn-search").on("click", function() {
      var $input = $('#shopify-section-header input[type="search"]');

      if ($input.val() == "") {
        showHeaderSearch();
      } else {
        $("#shopify-section-header .form-search button").trigger("click");
      }
    });

    $("#shopify-section-header .btn-search").on("mouseover", showHeaderSearch);
    $('#shopify-section-header input[type="search"]').focus();
    $('#shopify-section-header input[type="search"]').on("blur", function() {
      if ($("#shopify-section-header").is(":focus-within")) {
        //do nothing
      } else {
        hideHeaderSearch();
      }
    });

    //Search Results Styling & Weights Change Order
  });

//   window.weightsRan = false;
//   window.fetchWeights = function (explicit) {    
//     if (window.weightsRan == true && explicit != true) {
//       return;
//     }
//       var $container = $(".snize-search-results");

//       var productHandleString = "";

//       $container.find('[id^="snize-product-"]').each(
//         function(index, element) {
//           var prod_handle = $(element)
//             .find(".snize-view-link")
//             .attr("href")
//             .replace("https://zpacks.com/products/", "");
//           productHandleString =
//             productHandleString + " " + prod_handle.toString();
//         }.bind(this)
//       );

//       function grams2oz(grams) {
//         var num = Math.round((grams * (0.035274)) * 10) / 10;
//         console.log( num );
//         return num;
//       }

//       $.get("/search?type=product&q=" + productHandleString, function(data) {
//         var x = document.createElement("div");
//         x.innerHTML = data;

//         console.log( data );

//         var jsonString = x.querySelector(".search-weight-results").innerHTML;
//         var weightsObj = JSON.parse(jsonString);

//         for (var property in weightsObj) {
//           var selector =
//             '[href="https://zpacks.com/products/' + property + '"]';
          
//           $(selector)
//             .find(".snize-price")
//             .wrap('<div class="price-wrapper"></div>');
//           var $priceWrapper = $(selector).find(".price-wrapper");
//           var weightMarkup = `
//               <ul style="margin: 0" class="weight-markup">
//                 <li>
//                   <h6 style="font-weight: bold; font-size: 14px;">Weight</h6>
//                   <p style="margin-bottom: 0; line-height: normal; font-weight: normal; font-size: 14px;">${grams2oz(
//                     weightsObj[property]
//                   )} oz / ${weightsObj[property]} g</p>
//                 </li>
//               </ul>
//               <style>
//                 .price-wrapper {
//                   display: flex;
//                   align-items: flex-end;
//                 }
//                 .snize-overhidden, .snize-overhidden * {
//                   text-align: left !important;
//                 } 
//                 .snize-grid-mode-icon,
//                 .snize-list-mode-icon,
//                 .snize-main-panel-view-mode {
//                   display: none;
//                 }

//                 .snize-price {
//                   font-family: "Avenir Next Medium" !important;
//                 }
//               </style>
//               `;
//           $priceWrapper.closest(".snize-overhidden").css({
//             "background":
//               "url(//cdn.shopify.com/s/files/1/0004/4652/9572/t/21/assets/background-mountain.png?3423)",
//             "background-position": "center"
//           });
//           $priceWrapper.prepend(weightMarkup);
//         }
        
//       });

//       window.weightsRan = true;
//   }
    
//     var checkExist = setInterval(function() {
//        if ($('.snize-view-link').length != 0) {
//          window.fetchWeights();
//           clearInterval(checkExist);
//        }  
//     }, 50);  

//     function augment(withFn) {
//       var name, fn;
//       for (name in window) {
//           fn = window[name];
//           if (typeof fn === 'function') {
//               window[name] = (function(name, fn) {
//                   var args = arguments;
//                   return function() {
//                       withFn.apply(this, args);
//                       return fn.apply(this, arguments);
  
//                   }
//               })(name, fn);
//           }
//       }
//   }

// var timeSpent = 0; //seconds on page
// var timer;
// window.onload = function() {
//   timer = setInterval( function() { timeSpent++; }, 998 );
// };
  
//   augment(function(name, fn) {
//       if (name == 'btoa') {
//         window.fetchWeights();
//       }

//       if (name == 'btoa' && timeSpent > 2) {
//         window.fetchWeights(true);
//       }
//   });  

//   setTimeout(function() {
//     window.fetchWeights();
//   }, 1000);

})(jQuery);



